import React, { useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import AiAssistant from '../navbar/AiAssistant';
import SpeechAnalysis from '../navbar/SpeechAnalysis';
import CyberRoom from '../navbar/CyberRoom/CyberRoom';
import AlertsPage from '../sidebar/AlertsPage';
import '../../styles/layout/Layout.css';
import Footer from './Footer';
import VPNDetector from '../navbar/VPNDetector';
import DarkNetwork from '../navbar/DarkNetwork';
import ReportsPage from '../sidebar/ReportsPage';
import TargetBank from '../sidebar/TargetBank';
import BotNetworks from '../sidebar/BotNetworks';
import ScanRoom from '../sidebar/ScanRoom';
import ProfileSearch from '../sidebar/ProfileSearch';
import DeepfakeScanner from '../sidebar/DeepfakeScanner';
import HashtagMonitor from '../sidebar/HashtagMonitor';
import ListAnalysis from '../sidebar/ListAnalysis';
import Settings from '../sidebar/Settings';
import MamdaniPage from '../../pages/MamdaniPage';
import { useMamdani } from '../../context/MamdaniContext';

function Layout({ children, onLogout, connected }) {
  const [showAiAssistant, setShowAiAssistant] = useState(false);
  const [showSpeech, setShowSpeech]           = useState(false);
  const [showCyber, setShowCyber]             = useState(false);
  const [activePage, setActivePage]           = useState('monitor');
  const [showDark, setShowDark]               = useState(false);
  const [sidebarOpen, setSidebarOpen]         = useState(false);
  const [showVPN, setShowVPN]                 = useState(false);
  const [sidebarPage, setSidebarPage]         = useState(null);
  const { mamdaniMode, toggleMode } = useMamdani();

  const handleNavPageChange = (page) => {
    setShowAiAssistant(false);
    setShowSpeech(false);
    setShowCyber(false);
    setShowVPN(false);
    setShowDark(false);
    setSidebarPage(null);

    if (page === 'mamdani') {
      if (!mamdaniMode) {
        setActivePage('mamdani');
      } else {
        setActivePage('monitor');
      }
      toggleMode();
      return;
    }

    setActivePage(page);
    if (page === "ai")     setShowAiAssistant(true);
    if (page === "speech") setShowSpeech(true);
    if (page === "cyber")  setShowCyber(true);
    if (page === "vpn")    setShowVPN(true);
    if (page === "dark")   setShowDark(true);
  };

  const handleSidebarNavigate = (id) => {
    if (id === 'dashboard') {
      setSidebarPage(null);
      return;
    }
    setSidebarPage(id);
    setShowAiAssistant(false);
    setShowSpeech(false);
    setShowCyber(false);
    setShowVPN(false);
    setShowDark(false);
  };

  const renderMain = () => {
    if (sidebarPage === 'alerts')  return <AlertsPage />;
    if (sidebarPage === 'reports') return <ReportsPage />;
    if (sidebarPage === 'targets') return <TargetBank />;
    if (sidebarPage === 'botnets') return <BotNetworks />;
    if (sidebarPage === 'profiles') return <ProfileSearch />;
    if (sidebarPage === 'deepfake') return <DeepfakeScanner />;
    if (sidebarPage === 'hashtags') return <HashtagMonitor />;
    if (sidebarPage === 'listanalysis') return <ListAnalysis />;
    if (sidebarPage === 'settings')    return <Settings />;

    if (activePage === 'mamdani') return <MamdaniPage />;
    if (showSpeech)            return <SpeechAnalysis />;
    if (showCyber)             return <CyberRoom />;
    if (showVPN)               return <VPNDetector />;
    if (activePage === 'dark') return <DarkNetwork />;
    if (showAiAssistant)       return <AiAssistant onClose={() => { setShowAiAssistant(false); if (mamdaniMode) setActivePage('mamdani'); }} />;

    return children;
  };

  const showScanRoom = sidebarPage === 'impersonation';

  return (
    <div className="layout-outer">
    <div className="layout">


      <Navbar
        onLogout={onLogout}
        onPageChange={handleNavPageChange}
        active={activePage}
        connected={connected}
        onToggleSidebar={() => setSidebarOpen(prev => !prev)}
      />

      <div className="layout-content">

        {sidebarOpen && (
          <Sidebar
            activePage={sidebarPage || 'dashboard'}
            onNavigate={handleSidebarNavigate}
          />
        )}

        <main className="main-content">

          {/* ScanRoom - תמיד קיים בDOM, רק מוסתר כשלא פעיל */}
          <div style={{ display: showScanRoom ? 'block' : 'none' }}>
            <ScanRoom />
          </div>

          {/* שאר העמודים - מוצגים רק כשלא בScanRoom */}
          {!showScanRoom && renderMain()}

        </main>

      </div>

      <Footer />
    </div>
    </div>
  );
}

export default Layout;